export default {
  RentalPackage: "RentalPackage",
  AddRentalPackage: "AddRentalPackage",
  editRentalPackage: "EditRentalPackage",
};
